enum SurveyQuestionType {
  Description = 1,
  Number,
  FreeResponse,
  Choice_Single,
  Choice_Multi
}

type PreviousAnswer = {
  checkboxes: boolean[];
  radio: string;
  isOtherSelected: boolean;
  other: string;
}

type SurveyQuestionData = {
  // Number
  min?: number;
  max?: number;

  // FreeResponse
  minLength?: number;
  maxLength?: number;

  // Choice
  choices?: string[];

  // For visibility toggling
  hideIf?: [];
};

type SurveyQuestion = {
  id: number;
  seq?: number;
  survey_id: number;
  type: SurveyQuestionType;
  prompt: string;
  data?: string;

  // UI properties
  show: boolean;

  // The below properties are related to respones
  allow_multiple: boolean;
  allow_other: boolean;
  props: SurveyQuestionData;
  previous: PreviousAnswer;
};

type SurveyPublic = {
  id: number;
  name: string;
  description: string;
  icon: string;

  // Exist only on surveys that have been completed
  score?: number;
  submitted_date?: string;
  completion_id?: string;

  // Additional state, fetched on demand
  questions?: SurveyQuestion[];
};

// Barebones description of a survey completion
type SurveyCompletionRecord = {
  completion_id: string;
  score?: number;
  submitted_date: string;
};

// Answer to a question, and the question
type AnswerPerspective = {
  question_id: number;
  answer_text?: string;
  answer_int?: number;

  type: SurveyQuestionType;
  prompt: string;
  data?: string;

  props?: SurveyQuestionData;
};

// Warning for when COST score is below a certain threshold
type ScoreWarning = {
  message?: string;
  BodyCss?: string;
  ScoreCss?: string;
};

enum AuthMethodType {
  Unknown = 0,
  Local,
  Google,
  Facebook,
}

enum UserRoleType {
  Patient = 1,
  Navigator,
  Admin,
}

enum SurveyType {
  Demo = 1,
  COST,
  SDoH,
  CHLT6
}

class SessionDetails {
  authMethod!: AuthMethodType;
  expires!: string;
  picture?: string;
  role?: UserRoleType;
}

export {
  AnswerPerspective,
  AuthMethodType,
  PreviousAnswer,
  ScoreWarning,
  SessionDetails,
  SurveyCompletionRecord,
  SurveyPublic,
  SurveyQuestion,
  SurveyQuestionData,
  SurveyQuestionType,
  SurveyType,
  UserRoleType,
};
